import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSharingModal } from '/src/hooks';
import { useAuthContext } from '/src/hooks/useAuthContext';

function messageHandler(event) {
  const allowedOrigin = new URL(window.CORE_API_URL).origin;

  if (event.origin !== allowedOrigin) return;

  if (event.data?.subject === 'snapshot-report:hash-change') {
    window.location.hash = event.data.hash;
  }

  if (event.data?.subject === 'snapshot-report:show-sharing') {
    window.SharingModal?.show({
      entity: {
        id: event.data.snapshotId,
        type: 'SNAPSHOT',
        originalUrl: window.location.href,
      },
    });
  }
}

function startListeningForMessages() {
  window.addEventListener('message', messageHandler);
}

function stopListeningForMessages() {
  window.removeEventListener('message', messageHandler);
}

export function SnapshotReportPage() {
  const { id } = useParams();
  const { isSharing } = useAuthContext();

  useSharingModal(undefined, undefined, !isSharing);

  useEffect(() => {
    startListeningForMessages();
    return () => stopListeningForMessages();
  });

  return (
    <iframe
      src={`${window.CORE_API_URL}/snapshot/${id}${window.location.search}${window.location.hash}`}
      id="snapshotDetails"
      title="Snapshot Report"
      width="100%"
      height="100%"
    />
  );
}
